// extracted by mini-css-extract-plugin
export var accordionContent = "styles-module--accordionContent--ca3c9";
export var active = "styles-module--active--7a986";
export var button = "styles-module--button--011f1";
export var chevron = "styles-module--chevron--0c927";
export var content = "styles-module--content--f760f";
export var questionText = "styles-module--questionText--8ecd0";